




























import Vue from 'vue';
import { sanityClient } from '@/config/sanity';
import Insurance from '@/models/insurance';
import Language from '@/models/language';
import SanityBlockContentModel from '@/models/sanitySchema/sanityBlockContent';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';

interface InsurancesPage {
  title: string;
  content: SanityBlockContentModel;
  insurances: Array<Insurance>;
}

interface Data {
  isLoading: boolean;
  error: string;
  page: InsurancesPage | null;
}

export default Vue.extend({
  name: 'Insurances',
  components: {
    LoadingIndicator,
    ErrorMessage,
    SanityBlockContent,
    SpeakerWithGradient,
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      page: null,
    };
  },
  created() {
    this.fetchPage();
  },
  methods: {
    fetchInsurancesPage() {
      const query = `*[_type == "insurancesPage"]{
        "createdAt": _createdAt,
        "updatedAt": _updatedAt,
        "id": _id,
        "key": _key,
        "slug": slug.current,
        title,
        content,
        insurances,
      }[0]`;

      return sanityClient.fetch(query).then(
        (results) => {
          this.page = {
            ...results,
            insurances: results.insurances.filter((i: Insurance) => i.isListed && i.lang === Language.NO),
          };
        },
        (error) => {
          this.error = error;
        },
      );
    },
    fetchPage() {
      this.isLoading = true;
      Promise.all([
        this.fetchInsurancesPage(),
      ]).then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
  },
});
